export default __webpack_public_path__ + "static/media/element_spec_7.22ed3b99.webp";